"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ListItemSecondaryActionStart(props) {
  var children = props.children,
      className = props.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])('list-item--secondaryActionStart', className)
  }, children);
}

ListItemSecondaryActionStart.muiName = 'ListItemSecondaryActionStart';
ListItemSecondaryActionStart.propTypes = {
  /**
     * The content of the component, normally an `IconButton` or selection control.
     */
  children: _propTypes["default"].node,

  /**
     * Useful to extend the style applied to components.
     */
  className: _propTypes["default"].string,

  /**
     * @ignore
     */
  classes: _propTypes["default"].object
};
var _default = ListItemSecondaryActionStart;
exports["default"] = _default;